import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Modal, ModalBody, ModalHeader, Label, FormGroup, Spinner, Button } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'

import { BaseUrl } from "../../../helpers/Baseurl"
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';


class Payments extends Component {
    constructor(props) {
        super(props);
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj){
            this.props.history.push('/logout')
        }else if (!validateToken(this.obj.access)){
            this.props.history.push('/logout')
        }
        if(!has_Permission(this.obj.user, 7, 'read' )){
            this.props.history.push('/dashboard')
        }
        this.state = {
          breadcrumbItems: [
            { title : "Planmans", link : "/dashboard" },
            { title : "Payment Details", link : "#" }
        ],

            bank_name:"",
            ifsc:"",
            account_no:"",
            upi:"",
            account_name:"",
            branch_name:"",
            swift_code:"",
        }

        this.tog_edit_bank_detail = this.tog_edit_bank_detail.bind(this)
        this.tog_edit_upi_detail = this.tog_edit_upi_detail.bind(this)
        this.handleBankDetailSubmit = this.handleBankDetailSubmit.bind(this)
    }

    tog_edit_bank_detail() {
        this.setState(prevState => ({
            model_edit_bank_detail: !prevState.model_edit_bank_detail
        }));
        this.removeBodyCss();
      }

    tog_edit_upi_detail() {
      this.setState(prevState => ({
          model_edit_upi_detail: !prevState.model_edit_upi_detail
      }));
      this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
      }

    async componentDidMount() {
      document.title = "Payment Details | Planmans"
        this.loadBankDetaildata()
     }

    
    async loadBankDetaildata(){
        // let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            };
        await fetch(`${BaseUrl}/api/cms/payment-detail/1/`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {                   
                    this.setState({ bank_name: data.bank_name, swift_code:data.swift_code, ifsc:data.ifsc, account_no:data.account_no, upi:data.upi , account_name:data.account_name,
                                    branch_name:data.branch_name, model_edit_bank_detail:false, model_edit_upi_detail:false, loading:false })
                        },
                    
                (error) => {
                    console.log(error, 'error------') 
                }
            )  
    }

    handleBankDetailSubmit(e,values){
        const {bank_name, ifsc, account_no, upi, account_name,branch_name, swift_code }  = this.state
        this.setState({loading:true})
        let data = { 'bank_name': bank_name, 'ifsc':ifsc, 'swift_code':swift_code, 'account_no':account_no, 'upi':upi, 'account_name':account_name, 'branch_name':branch_name }
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' , 'Authorization':`Bearer ${this.obj.access}` },
            body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/cms/payment-detail/1/`,requestOptions)
                  .then(res => 
                      {if(res.status >= 400){
                          res.json()
                          .then(
                              (data) =>{  
                                console.log(data, "---data")
                                this.setState({ loading: false })
                              }
                                
                          )
                      }
                      else{
                        this.loadBankDetaildata()
                      }    
                  }
              )
    }

    render() {
        const {bank_name, ifsc, account_no, upi, account_name, branch_name, swift_code}  = this.state
       
        return (
            <React.Fragment>
        <div className="page-content">
          <Container fluid>

          <Breadcrumbs title={"Payment details"} breadcrumbItems={this.state.breadcrumbItems} />
          

            <Row>
              <Col xs={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">{"Bank detail"} </h4>
                    <ul className="list-unstyled mb-4">
                        <li className='mt-4'><h4 className="card-title mt-2" style={{color:"red"}}></h4>
                            <ul>
                                <li className='mt-4'>Account Name : {account_name}</li>
                                <li >Account Number : {account_no}</li>
                                <li>Bank Name : {bank_name} </li>
                                <li>Branch : {branch_name} </li>
                                <li>IFSC Code : {ifsc}</li>
                                <li>SWIFT Code : {swift_code}</li>

                            </ul>
                        </li>

                        
                    </ul>
                    {has_Permission(this.obj.user, 7, 'edit')?
                    <Link to="#" onClick={() => this.tog_edit_bank_detail() } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                    :null}

                  </CardBody>
                </Card>
              </Col>
              <Col xs={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">{"UPI detail"} </h4>
                    <ul className="list-unstyled mb-4">
                        <li className='mt-4'><h4 className="card-title mt-2" style={{color:"red"}}></h4>
                            <ul>
                                
                            <li className='mt-4'>Account Name : {account_name}</li>
                                <li>UPI : {upi}</li>

                            </ul>
                        </li>

                        
                    </ul>
                    {has_Permission(this.obj.user, 7, 'edit')?
                    <Link to="#" onClick={this.tog_edit_upi_detail } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
                    :null}

                  </CardBody>
                </Card>
              </Col>
            </Row>
         
          </Container>
        </div>
        <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_edit_bank_detail}
                 toggle={this.tog_edit_bank_detail}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_edit_bank_detail: false })}>
                 Edit Bank Detail
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleBankDetailSubmit} >
                      <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="account_name">Account Name</Label>
                                <AvField
                                    name="account_name"
                                    type="text"
                                    errorMessage="Enter Account Name"
                                    className="form-control"
                                    value= {account_name}
                                    validate={{ required: { value: true } }}
                                    onChange={(e)=> this.setState({account_name:e.target.value})}
                                    id="account_name"
                                    
                                />
                              </div>
                            </Col> 
                            <Col md={6}>
                                <div className="mb-3">
                                    <AvField
                                        name="account_no"
                                        label="Account Number"
                                        type="number"
                                        value= {account_no}
                                        errorMessage="Enter Only Digits"
                                        onChange={(e)=> this.setState({account_no:e.target.value})}
                                        validate={{
                                            required: { value: true },
                                            pattern: {
                                            value: "^[0-9]+$",
                                            errorMessage: "Only Digits"
                                            }
                                        }}
                                        />
                                </div>
                            </Col>
                              
                      </Row>           
     
                      <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                              <AvField
                                  name="bank_name"
                                  placeholder="Name"
                                  type="text"
                                  errorMessage="Enter Bank Name"
                                  className="form-control"
                                  value= {bank_name}
                                  validate={{ required: { value: true } }}
                                  onChange={(e)=> this.setState({bank_name:e.target.value})}
                                  id="bank_name"
                                  
                              />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                              <AvField
                                  name="branch_name"
                                  type="text"
                                  errorMessage="Enter Branch Name"
                                  className="form-control"
                                  value= {branch_name}
                                  validate={{ required: { value: true } }}
                                  onChange={(e)=> this.setState({branch_name:e.target.value})}
                                  id="branch_name"
                                  
                              />
                              </div>
                          </Col> 
                          
                      </Row>
                      <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                              <AvField
                                  name="ifsc"
                                  type="text"
                                  errorMessage="Enter IFSC Code"
                                  value= {ifsc}
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  onChange={(e)=> this.setState({ifsc:e.target.value})}
                                  id="ifsc"
                                  
                              />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label" htmlFor="swift_code">SWIFT Code</Label>
                              <AvField
                                  name="swift_code"
                                  type="text"
                                  errorMessage="Enter SWIFT Code"
                                  value= {swift_code}
                                  className="form-control"
                                  onChange={(e)=> this.setState({swift_code:e.target.value})}
                                  id="swift_code"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
     
                          
                                       
                     <FormGroup className="mb-0">
                       {this.state.loading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>
     
                 </ModalBody>
               </Modal>
             </Col>
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_edit_upi_detail}
                 toggle={this.tog_edit_upi_detail}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_edit_upi_detail: false })}>
                 Edit UPI Detail
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleBankDetailSubmit} >
     
                            <Row>
                               <Col md="6">
                                   <div className="mb-3">
                                   <Label className="form-label " htmlFor="upi">UPI</Label>
                                   <AvField
                                       name="upi"
                                       type="text"
                                       errorMessage="Enter UPI"
                                       className="form-control"
                                       value= {upi}
                                       onChange={(e)=> this.setState({upi:e.target.value})}
                                       validate={{ required: { value: true } }}
                                       id="upi"
                                       
                                   />
                                   </div>
                               </Col> 
                               
                           </Row>    
                                       
                     <FormGroup className="mb-0">
                       {this.state.loading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>
     
                 </ModalBody>
               </Modal>
             </Col>
      </React.Fragment>
        );
    }
}

export default Payments;
